import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { convertDayjsToUTC } from '@chiroup/core/functions/time';

export type DejavooPaymentPayload = {
  dejavooPaymentTokenId: string;
  dejavooCardLastFour?: string;
  dejavooCardType?: string;
  dejavooCardholderName?: string;
};

const appointmentService = () => {
  const create = async (
    body: any,
    paymentKey?: string,
    dejavooPayment?: DejavooPaymentPayload
  ): Promise<any> => {
    return ChiroUpAPI.post('api', `/appointment`, {
      body: {
        ...body,
        startTime: convertDayjsToUTC({ datetime: body.startTime }),
        endTime: convertDayjsToUTC({ datetime: body.endTime }),
        paymentKey,
        ...(dejavooPayment || {}),
        doubleBook: body.doubleBook,
      },
    });
  };

  // const createGuest = async (body: any): Promise<any> => {
  //   return ChiroUpAPI.post('api-noauth', `/appointment-guest`, {
  //     body,
  //   });
  // };

  const update = async (id: string, body: any): Promise<any> => {
    return ChiroUpAPI.put('api', `/appointment/${id}`, {
      body: {
        ...body,
        startTime: convertDayjsToUTC({ datetime: body.startTime }),
        endTime: convertDayjsToUTC({ datetime: body.endTime }),
      },
    });
  };

  return {
    create,
    // createGuest,
    update,
  };
};

export default appointmentService();
